import api from "./api/middleware";
import ui from "./ui/middleware";
import customer from "./customer/middleware";

const rootmiddleware = [...customer, ...api, ...ui];

export default rootmiddleware;
